import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = ({ userRole = 'admin' }) => {
  const navigate = useNavigate();

  const getActionsForRole = () => {
    const baseActions = [
      {
        label: 'Nueva Consulta VIN',
        description: 'Realizar búsqueda de información vehicular',
        icon: 'Search',
        action: () => navigate('/vin-consultation'),
        variant: 'default',
        primary: true
      },
      {
        label: 'Ver Historial',
        description: 'Revisar consultas y auditoría',
        icon: 'History',
        action: () => navigate('/history-and-audit-trail'),
        variant: 'outline'
      }
    ];

    if (userRole === 'admin') {
      baseActions?.push(
        {
          label: 'Gestión de Usuarios',
          description: 'Administrar cuentas y permisos',
          icon: 'Users',
          action: () => navigate('/user-administration'),
          variant: 'outline'
        },
        {
          label: 'Configuración',
          description: 'Políticas y seguridad del sistema',
          icon: 'Settings',
          action: () => navigate('/system-configuration'),
          variant: 'outline'
        }
      );
    }

    return baseActions;
  };

  const actions = getActionsForRole();

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation">
      <div className="flex items-center space-x-2 mb-4">
        <Icon name="Zap" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Acciones Rápidas</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action, index) => (
          <div
            key={index}
            className={`group cursor-pointer rounded-lg border border-border p-4 transition-all duration-200 hover:shadow-elevation-md ${
              action?.primary ? 'bg-primary/5 border-primary/20' : 'hover:bg-muted/50'
            }`}
            onClick={action?.action}
          >
            <div className="flex items-start space-x-3">
              <div className={`flex items-center justify-center w-10 h-10 rounded-lg transition-colors ${
                action?.primary 
                  ? 'bg-primary text-primary-foreground' 
                  : 'bg-muted text-muted-foreground group-hover:bg-primary group-hover:text-primary-foreground'
              }`}>
                <Icon name={action?.icon} size={20} />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground mb-1 group-hover:text-primary transition-colors">
                  {action?.label}
                </h4>
                <p className="text-xs text-muted-foreground line-clamp-2">
                  {action?.description}
                </p>
              </div>
              
              <Icon 
                name="ArrowRight" 
                size={16} 
                className="text-muted-foreground group-hover:text-primary transition-colors opacity-0 group-hover:opacity-100" 
              />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <Button
          variant="outline"
          fullWidth
          iconName="ExternalLink"
          iconPosition="right"
          onClick={() => navigate('/vin-consultation')}
          className="text-sm"
        >
          Ver Todas las Funciones
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;